import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup, Validators } from '@angular/forms';
import { PasswordType } from '../../interfaces/reset-pwd.interface';
import { Subject } from 'rxjs';
import { CheckboxComponent, DropdownComponent, EmailComponent, EqValidator, NumberInputComponent, PasswordComponent, RadioButtonComponent, SearchComponent, TextAreaComponent, TextInputComponent } from '@equine-ui-nx/ui';
import { CustomValidator } from './custom.validators';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
@Component({
  selector: 'update-password-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatIconModule,
    EmailComponent,
    PasswordComponent,
    CheckboxComponent,
    TextAreaComponent,
    TextInputComponent,
    RadioButtonComponent,
    SearchComponent,
    DropdownComponent,
    NumberInputComponent],
  templateUrl: './update-password-form.component.html',
  styleUrl: './update-password-form.component.scss',
})
export class UpdatePasswordFormComponent implements OnInit {
  @Output() resetpasswordFormData: EventEmitter<any> = new EventEmitter<any>();
  @Input() isPasswordUpdate: boolean = false;
  @Input() appName!: string;
  ResetPasswordForm = new FormGroup({});
  unsubscribe$ = new Subject<void>();
  showPassword: boolean = false;
  showConfrimPassword: boolean = false;
  passwordType = PasswordType;
  resetPwdError: string = '';
  loading: boolean = false;
  token: any;
  decodedToken: any;
  backgroundImageId!: string
  logoUrl!: string
  passwordValidator: EqValidator[] = [
    {
      validators: Validators.required,
      message: 'This field is required',
      error: 'required',
    },
    // {
    //   validators: Validators.minLength(10),
    //   message: 'Minimum 10 characters is required',
    //   error: 'minlength',
    // },
    {
      validators: Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{10,50}$/),
      message: 'password must be 10 characters including uppercase, lowercase, number and special characters',
      error: 'pattern'
    }
    
  ];

  confirmPasswordValidator: EqValidator[] = [
    {
      validators: Validators.required,
      message: 'This field is required',
      error: 'required',
    },

    {
      validators: CustomValidator.customValidate(),
      message: 'Password does not match',
      error: 'notMatched'
    }
  ];

  constructor(private router: Router) { }
  ngOnInit(): void {
    if(this.appName == 'arenaEqApp'){
      this.backgroundImageId = 'intro-arena';
      this.logoUrl = `assets/images/arenaEq-logo.png`
    }else{
      this.backgroundImageId = 'intro-iea';
      this.logoUrl = `../../../assets/images/access-logo-full.png`
    }
  }
  async ResetPassword() {
    if (this.ResetPasswordForm.valid) {
      this.resetpasswordFormData.emit(this.ResetPasswordForm);
  }  
  }

  public togglePasswordVisibility(type: PasswordType) {
    if (type === PasswordType.PASSWORD) {
      this.showPassword = !this.showPassword;
    } else {
      this.showConfrimPassword = !this.showConfrimPassword;
    }
  }

  onFieldChange(fieldName: string, value: any) {
    switch (fieldName) {
      case 'password':
        if (this.ResetPasswordForm.get('confirmPassword')?.value) {
          this.onFieldChange('confirmPassword', null);
        }
        break;

      case 'confirmPassword':
        if (this.ResetPasswordForm.get('password')?.value == this.ResetPasswordForm.get('confirmPassword')?.value) {
          this.ResetPasswordForm.get('confirmPassword')?.setErrors(null);
        } else {
          this.ResetPasswordForm.get('confirmPassword')?.setErrors({ 'notMatched': true });
        }
        break;

    }
  }

  signIn(){
    this.router.navigate(['/account/login']);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
